module.exports = __webpack_public_path__ + "img/agreement_btn_en.e7387ed5.png";